import toast from "react-hot-toast";
import SliderMenu from "./SliderMenu";
import { HiMiniBars3 } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { MdLocationOn } from "react-icons/md";
import { TbCurrentLocation } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postLocation, searchLocation, getSessionLocation } from "../../redux/ApiSlice/LocationSlice";
const browser = (() => {
    const ua = navigator.userAgent;
    if (ua.includes("Edg/")) return "edge";
    if (ua.includes("Chrome")) return "chrome";
    if (ua.includes("Firefox")) return "firefox";
    if (ua.includes("Safari")) return "safari";
    return "other";
})();

const BROWSER_STEPS = {
    chrome: [
        'Click the 🔒 lock icon in the address bar',
        'Select "Site settings"',
        'Under Permissions, find "Location"',
        'Change it from "Block" to "Allow"',
    ],
    edge: [
        'Click the 🔒 lock icon in the address bar',
        'Click "Permissions for this site"',
        'Find "Location" and set to "Allow"',
    ],
    firefox: [
        'Click the 🔒 lock icon in the address bar',
        'Click ">" next to "Connection secure"',
        'Click "More information" → "Permissions" tab',
        'Find "Access Your Location" → select "Allow"',
    ],
    safari: [
        'Open Safari menu → "Settings for This Website"',
        'Find "Location" and change to "Allow"',
    ],
    other: [
        'Click the lock or info icon in the address bar',
        'Go to site permissions or settings',
        'Find "Location" and set to "Allow"',
    ],
};

const NeighborLocation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { User_profile } = useSelector((state) => state.AccountProfile);
    const { loading, sessionLocation } = useSelector((state) => state.LocationAddress);


    const [newLocation, setNewLocation] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [locationDetails, setLocationDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDetecting, setIsDetecting] = useState(false);

    const [showLocationPrompt, setShowLocationPrompt] = useState(false);
    const [browserPermission, setBrowserPermission] = useState("prompt"); // "granted" | "denied" | "prompt"
    const permissionStatusRef = useRef(null);

    useEffect(() => {
        if (!navigator.permissions) return;
        navigator.permissions.query({ name: "geolocation" }).then((status) => {
            setBrowserPermission(status.state);
            permissionStatusRef.current = status;
            status.onchange = () => setBrowserPermission(status.state);
        });
        return () => {
            if (permissionStatusRef.current)
                permissionStatusRef.current.onchange = null;
        };
    }, []);

    // Auto-proceed when user enables location in browser while the guide is open
    useEffect(() => {
        if (!showLocationPrompt || browserPermission !== "granted") return;
        const t = setTimeout(() => {
            setShowLocationPrompt(false);
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    setLatitude(lat);
                    setLongitude(lng);
                    uploadLoacation(lat, lng, "while_using");
                },
                () => {
                    toast.error("Unable to get location. Please try again.");
                    setIsDetecting(false);
                }
            );
        }, 600);
        return () => clearTimeout(t);
    }, [browserPermission, showLocationPrompt]);

    // Called directly from a button click — keeps browser user-gesture context intact
    const handleLocationChoice = (choice) => {
        setShowLocationPrompt(false);

        if (choice === "deny") {
            setIsDetecting(false);
            return;
        }

        if (!navigator.geolocation) {
            toast.error("Geolocation is not supported by this browser.");
            setIsDetecting(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                setLatitude(lat);
                setLongitude(lng);
                uploadLoacation(lat, lng, choice);
            },
            (error) => {
                console.error("Error detecting location:", error);
                toast.error("Location is blocked in your browser. Enable it in site settings to use location features.");
                setIsDetecting(false);
            }
        );
    };


    useEffect(() => {
        dispatch(getSessionLocation());
    }, [dispatch]);

    useEffect(() => {
        if (User_profile.full_address) {
            setNewLocation(User_profile?.full_address);
        }
    }, [User_profile.full_address]);

    const toggleMenu = () => setMenuOpen(prev => !prev);

    const uploadLoacation = async (lat, lng, permissionType) => {
        try {
            const responce = await dispatch(postLocation({ latitude: lat, longitude: lng, permission_type: permissionType }));

            if (responce?.payload?.message) {
                toast.success(responce?.payload?.message);
                dispatch(getSessionLocation());
                if (responce.payload) {
                    setLocationDetails(responce.payload);
                    const city = responce.payload.city || responce.payload.town || responce.payload.village || '';
                    const state = responce.payload.state || '';
                    const country = responce.payload.country || '';
                    const formattedLocation = [city, state, country].filter(Boolean).join(', ');
                    setNewLocation(formattedLocation);
                }
            }
        } catch (error) {
            toast.error("Error fetching address details");
        } finally {
            setIsDetecting(false);
        }
    }

    const handleDetectLocation = () => {
        setIsDetecting(true);
        if (browserPermission === "granted") {
            // Already allowed — skip popup, get location directly
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    setLatitude(lat);
                    setLongitude(lng);
                    uploadLoacation(lat, lng, "while_using");
                },
                () => {
                    toast.error("Unable to get location. Please try again.");
                    setIsDetecting(false);
                }
            );
        } else {
            // "denied" or "prompt" — show popup
            setShowLocationPrompt(true);
        }
    };
    const handleSearchLocation = async () => {
        setIsLoading(true);
        try {
            const response = await dispatch(searchLocation(newLocation));
            if (response?.payload) {
                setLocationDetails(response.payload.data);
                toast.success("Location saved successfully");
            }
        } catch (error) {
            console.error("Error searching location:", error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Fragment>
            <div className="sticky top-0 bg-white dark:bg-[#1E1D21] pb-[2px] z-10">
                <div className="flex items-center justify-between bg-[#BDE6FF] shadow-md rounded-b-xl px-2 py-1">
                    <IoMdArrowBack
                        onClick={() => navigate("/neighborhood")}
                        className="text-[24px] cursor-pointer text-black dark:text-black"
                    />
                    <div className="flex flex-col items-center">
                        <p className="font-bold text-[18px] text-black dark:text-black">
                            Your Neighborhood
                        </p>
                        <p className="flex items-center text-[10px] text-black dark:text-black">
                            <IoLocationOutline className="text-[14px] ml-[-3px]" />
                            <span className="ml-1 text-[10px] line-clamp-1">
                                {sessionLocation?.city || sessionLocation?.country
                                    ? `${sessionLocation?.city ?? ''}, ${sessionLocation?.country ?? ''}`.replace(/^,\s*|,\s*$/, '').trim()
                                    : User_profile?.session_location?.city || User_profile?.session_location?.country
                                        ? `${User_profile.session_location.city ?? ''}, ${User_profile.session_location.country ?? ''}`.replace(/^,\s*|,\s*$/, '').trim()
                                        : User_profile?.city || User_profile?.country
                                            ? `${User_profile?.city ?? ''}, ${User_profile?.country ?? ''}`.replace(/^,\s*|,\s*$/, '').trim()
                                            : 'No Location'}
                            </span>
                        </p>
                    </div>
                    <HiMiniBars3
                        onClick={toggleMenu}
                        className="text-[24px] text-black dark:text-black cursor-pointer"
                    />
                </div>
            </div>

            <div className="p-4">
                <div className="mb-4">
                    <label className="block text-[14px] font-medium dark:text-gray-400 text-black">
                        Your Location
                    </label>
                    <input
                        value={newLocation}
                        placeholder="Detect your location to save"
                        onChange={e => setNewLocation(e.target.value)}
                        className="mt-1 block w-full text-[12px] border dark:bg-[#333333] dark:text-gray-200 border-gray-300 dark:border-gray-800/50 rounded-md shadow-sm p-2 outline-none"
                    />
                </div>
                {newLocation !== User_profile?.full_address && <div className="flex justify-center items-center w-full mb-4">
                    <button
                        onClick={handleSearchLocation}
                        disabled={isLoading}
                        className="flex items-center justify-center w-[100%] bg-[#BDE6FF]  text-black py-2 rounded-lg transition-colors duration-300"
                    >
                        {isLoading ? "Detecting..." : "Confirm Location"}
                    </button>
                </div>}
                <div className="flex justify-center items-center w-full mb-4">
                    <button
                        onClick={handleDetectLocation}
                        disabled={isDetecting || loading}
                        className="flex items-center justify-center w-[100%] bg-[#3d3d3b] hover:bg-[#252524] text-white py-2 rounded-lg transition-colors duration-300"
                    >
                        <TbCurrentLocation className="text-[16px] mr-1" />
                        {isDetecting || loading ? "Detecting..." : "Detect Location"}
                    </button>
                </div>

                {locationDetails && (
                    <div className="mt-4 p-3 border border-gray-200 rounded-lg bg-gray-50 dark:bg-[#333333]">
                        <h3 className="font-bold text-lg mb-2 dark:text-gray-200">Location Details</h3>
                        <div className="space-y-1 text-sm">
                            {/* {locationDetails.road && (
                                    <p className="dark:text-gray-100"><span className="font-medium dark:text-gray-400">Street:</span> {locationDetails.road}</p>
                                )} */}
                            {(locationDetails.district || locationDetails.neighbourhood) && (
                                <p className="dark:text-gray-100"><span className="font-medium dark:text-gray-400">Area:</span> {locationDetails.district || locationDetails.neighbourhood}</p>
                            )}
                            {(locationDetails.city || locationDetails.town || locationDetails.village) && (
                                <p className="dark:text-gray-100"><span className="font-medium dark:text-gray-400">City:</span> {locationDetails.city || locationDetails.town || locationDetails.village}</p>
                            )}
                            {locationDetails.state && (
                                <p className="dark:text-gray-100"><span className="font-medium dark:text-gray-400">State:</span> {locationDetails.state}</p>
                            )}
                            {locationDetails.postcode && (
                                <p className="dark:text-gray-100"><span className="font-medium dark:text-gray-400">Postal Code:</span> {locationDetails.postcode}</p>
                            )}
                            {locationDetails.country && (
                                <p className="dark:text-gray-100"><span className="font-medium dark:text-gray-400">Country:</span> {locationDetails.country}</p>
                            )}
                            <p className="text-xs text-gray-100 mt-2">
                                <span className="font-medium dark:text-gray-500">Coordinates:</span> {latitude?.toFixed(6)}, {longitude?.toFixed(6)}
                            </p>
                        </div>
                    </div>
                )}
            </div>

            {menuOpen &&
                <SliderMenu
                    onClose={() => setMenuOpen(false)}
                />
            }

            {/* Location Permission Dialog */}
            {showLocationPrompt && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
                    <div className="w-full max-w-sm bg-white dark:bg-[#1E1D21] rounded-2xl px-6 pt-6 pb-10">

                        {browserPermission === "denied" ? (
                            <>
                                <div className="flex justify-center mb-3">
                                    <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
                                        <MdLocationOn className="text-[28px] text-red-500" />
                                    </div>
                                </div>
                                <p className="text-center text-[15px] font-bold text-black dark:text-white mb-1">
                                    Location Access Blocked
                                </p>
                                <p className="text-center text-[11px] text-gray-500 dark:text-gray-400 mb-4">
                                    To use location features, enable it in your browser:
                                </p>
                                <div className="bg-gray-50 dark:bg-[#2a2a2e] rounded-xl p-3 mb-4 space-y-2">
                                    {BROWSER_STEPS[browser].map((step, i) => (
                                        <div key={i} className="flex items-start gap-2">
                                            <span className="min-w-[20px] h-5 rounded-full bg-[#BDE6FF] text-black text-[10px] font-bold flex items-center justify-center mt-0.5">
                                                {i + 1}
                                            </span>
                                            <p className="text-[11px] text-gray-700 dark:text-gray-300">{step}</p>
                                        </div>
                                    ))}
                                </div>
                                <div className="flex items-center justify-center gap-2 mb-4">
                                    <span className="w-2 h-2 rounded-full bg-[#BDE6FF] animate-pulse" />
                                    <p className="text-[11px] text-gray-500 dark:text-gray-400">Waiting for location access...</p>
                                </div>
                                <button
                                    onClick={() => { setShowLocationPrompt(false); setIsDetecting(false); }}
                                    className="w-full h-11 rounded-xl border border-gray-300 dark:border-gray-600 text-black dark:text-white text-[14px] font-semibold"
                                >
                                    Cancel
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="flex justify-center mb-3">
                                    <div className="w-14 h-14 rounded-full bg-[#BDE6FF] flex items-center justify-center">
                                        <MdLocationOn className="text-[28px] text-black" />
                                    </div>
                                </div>
                                <p className="text-center text-[15px] font-bold text-black dark:text-white mb-1">
                                    Allow "Chaa Chingg" to access your location?
                                </p>
                                <p className="text-center text-[11px] text-gray-500 dark:text-gray-400 mb-6">
                                    Your location helps us show nearby neighbourhood content.
                                </p>
                                <button
                                    onClick={() => handleLocationChoice("while_using")}
                                    className="w-full h-11 mb-3 rounded-xl bg-[#BDE6FF] text-black text-[14px] font-semibold"
                                >
                                    Allow While Using App
                                </button>
                                <button
                                    onClick={() => handleLocationChoice("once")}
                                    className="w-full h-11 mb-3 rounded-xl bg-[#BDE6FF] text-black text-[14px] font-semibold"
                                >
                                    Allow Once
                                </button>
                                <button
                                    onClick={() => handleLocationChoice("deny")}
                                    className="w-full h-11 rounded-xl border border-gray-300 dark:border-gray-600 text-black dark:text-white text-[14px] font-semibold"
                                >
                                    Don't Allow
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default NeighborLocation;